import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import DashBoard from '../../../components/DashBoard/DashBoard';
import HorsesCard from '../../../components/HorsesCard/HorsesCard';
import Loader from '../../../components/Loader/Loader';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import useFilters from '../../../hooks/useFilters';
import useUpdateFilterParams from '../../../hooks/useUpdateFilterParams';
import { useAppSelector } from '../../../store/reducers';
import { saveFilteredHorses } from '../../../store/reducers/Stable/slice';
import { horsesFilterConfig } from '../HorseFilters/horseFilterConfig';
import HorseFilters from '../HorseFilters/HorseFilters';
import styles from '../RaceStableList.module.scss';
const HorsesList = ({ filters }) => {
    const { pending, horses } = useAppSelector(({ stable }) => stable);
    const { isConnected } = useAppSelector(({ wallet }) => wallet.activeWallet);
    const { t } = useTranslation();
    const filteredHorses = useFilters(horses, horsesFilterConfig, saveFilteredHorses);
    useUpdateFilterParams();
    return (_jsx(DashBoard, Object.assign({ className: styles.raceView }, { children: _jsxs("div", Object.assign({ className: cn('d-flex') }, { children: [_jsx(HorseFilters, { horseView: true, filter: filters }), _jsx("div", Object.assign({ className: styles.cardsBox }, { children: pending || !isConnected ? (_jsx(Loader, { className: cn('d-flex align-items-start', styles.loader) })) : (filteredHorses === null || filteredHorses === void 0 ? void 0 : filteredHorses.length) !== 0 ? (_jsx(HorsesCard, { filters: filters, horses: filteredHorses })) : (_jsx(Paragraph, { title: t('no_results') })) }))] })) })));
};
export default HorsesList;
